<template>
    <input
        class="form-control"
        @input="$emit('input', $event.target.value)"
        :minlength="minlength"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :type="type"
        :value="value"
        :name="name"
        :id="name"
    />
</template>
<script>
export default {
    name: "TextField",
    emits: ["update:model-value", "input"],
    props: ["minlength","maxlength","type","placeholder","value","name","label"]
}
</script>
